<template>


    <app-layout :title="__('Languages')">


        <div class="">


            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8">


                <div
                    style="grid-template-rows:  max-content minmax(200px, max-content);"
                    class="grid grid-cols-2">


                    <div class="my-4 row-start-1 flex items-center">


                        <h1 class="text-2xl font-nexa text-dark-blue"
                            style="height: 30px">

                            Languages

                        </h1>


                        <div class=""
                             style="height: 22px">


                            <font-awesome-icon
                                class="ml-8 justify-center font-bold"
                                style="width: 16px; height: 16px; margin-top: 4px;"
                                size="sm"
                                :icon="['far', 'filter']" />


                            <filter-drop-down
                                :selected="selected_topic"
                                :choices="dropdown_topics"
                                @clicked_item="(choice) => { this.handle_click_dropdown('topic',choice) }"/>


                        </div>


                    </div>


                    <NordenTable
                        :headers="language_headers"
                        :rows="language_rows" />


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>
import { defineComponent } from 'vue'
import AppLayout from '../Layouts/AppLayout.vue'
import NordenTable from "@/Components/NordenTable";
import FilterDropDown from "@/Components/FilterDropDown";

export default defineComponent({

    components: {
        FilterDropDown,
        NordenTable,
        AppLayout,
    },

    props: {
        language_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        name: 'Language',
                        value_key: 'title',
                        text_key: 'title',
                        column_width: 3,
                        class: 'leading-[50px] min-h-[50px]',
                    },
                    {
                        name: 'Subscribers',
                        text_key: 'subscribers',
                        value_key: 'subscribers',
                        column_width: 1,
                        class: '',
                    },
                    {
                        name: 'Content Clicks',
                        value_key: 'content_clicks',
                        text_key: 'content_clicks',
                        column_width: 4,
                        class: ''
                    },
                ]
            }
        },
        languages: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        title: 'English',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                        class: '',
                    },
                    {
                        id: 2,
                        title: 'Danish',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 3,
                        title: 'Swedish',
                        subscribers: 2,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 4,
                        title: 'Norwegian',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 5,
                        title: 'Finnish',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },

                    {
                        id: 5,
                        title: 'Icelandic',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                ];
            }
        },

        selected_topic: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'All Topics'
                }
            }
        },

        dropdown_topics: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Countries and Regions',
                    },
                    {
                        id: 2,
                        name: 'Culture, Leisure and Media',
                    },
                    {
                        id: 3,
                        name: 'Legislation and Justice',
                    },
                    {
                        id: 4,
                        name: 'Environment and Climate',
                    },
                    {
                        id: 5,
                        name: 'The Nordic Region and the Surrounding World'
                    },
                    {
                        id: 6,
                        name: 'Education and Research'
                    },
                    {
                        id: 7,
                        name: 'Welfare and Gender Equality'
                    },
                    {
                        id: 8,
                        name: 'Economy, Business and Working Life'
                    },
                    {
                        id: 9,
                        name: 'Nordic Council prizes'
                    },
                    {
                        id: 10,
                        name: 'Nordic Council sessions'
                    }

                ]

            },

        },
    },


    computed: {

        language_rows() {

            return _.map(this.languages, (languages) => {

                return languages;

            });

        }

    },


    methods: {


        handle_click_dropdown(field, choice) {

            let
                parameters = this.route().params
            ;

            parameters[field] = choice.id

            this.$inertia.visit(
                this.route('languages', parameters)
            );

        }

    }

})
</script>


